import React from 'react'
import { UserVehicleLink } from '../userVehicleLinkHOC'

interface UserVehicleLinkProps {
  leftText: string
  pillText: undefined | string
  children?: any
}

const CardWrapper = ({
  leftText,
  pillText,
  children,
}: UserVehicleLinkProps) => {
  return (
    <div className="card packages-card">
      <div className="card__header user-vehicles__line">
        <h3 className="card__title">
          <span>{leftText}</span>
          {pillText && <span className="context-pill">{pillText}</span>}
        </h3>
      </div>
      <ul className="card__body">{children}</ul>
    </div>
  )
}

export default UserVehicleLink(CardWrapper)
